import { FC } from 'react';

interface Props {
    leftPanel?: JSX.Element;
    content: JSX.Element;
    className?: string;
}

const InnerLayout: FC<Props> = (props) => {
    const colStyle = 'col-span-12';
    const contentStyle = props.leftPanel ? `${colStyle} lg:col-span-9` : colStyle;

    return (
        <div className={'grid grid-cols-12 gap-6' + (props.className ? ' ' + props.className : '')}>
            {props.leftPanel && <div className="col-span-12 lg:col-span-3">{props.leftPanel}</div>}
            <div className={contentStyle}>{props.content}</div>
        </div>
    );
};

export default InnerLayout;
